import React from "react";

const C2BenefitsHead = () => {
  return (
    <div className="lvlBenefitsHead">
      <h2>
        Benefits of C2 Level German Course at <span>Prizma Academy</span>
      </h2>
      <p>
        Elevate your German proficiency to the highest level with our C2 Level
        German Course. Here’s what you can expect:
      </p>
    </div>
  );
};

export default C2BenefitsHead;
